import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=dcdf39f0&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=dcdf39f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcdf39f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dcdf39f0')) {
      api.createRecord('dcdf39f0', component.options)
    } else {
      api.reload('dcdf39f0', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=dcdf39f0&scoped=true&", function () {
      api.rerender('dcdf39f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22WdDslgyba3B/JS/comp/DocBox.vue"
export default component.exports